import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

import { cn } from '@/lib/utils'

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & { size?: 'large' | 'sm' }
>(({ className, size = 'sm', ...props }, ref) => (
  <SwitchPrimitives.Root
    data-size={size}
    className={cn(
      'peer inline-flex data-[size=sm]:h-5 data-[size=sm]:w-9 data-[size=large]:h-6 data-[size=large]:w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed data-[state=checked]:bg-accent-default data-[state=checked]:disabled:bg-accent-tr-12 data-[state=unchecked]:bg-gray-default data-[state=unchecked]:disabled:bg-gray-tr-12',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      data-size={size}
      className={cn(
        'pointer-events-none block data-[size=sm]:h-4 data-[size=sm]:w-4 data-[size=large]:h-5 data-[size=large]:w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:data-[size=sm]:translate-x-4 data-[state=checked]:data-[size=large]:translate-x-5 data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
